import { combineReducers } from "redux";

import restaurantsReducer from "./restaurants/reducer";
import dishesReducer from "./dishes/reducer";
import user from "./user/reducer";
import appState from "./appState/reducer";

export default combineReducers({
  restaurants: restaurantsReducer,
  dishes: dishesReducer,
  user,
  appState,
});
